import { DataPackValue } from 'app/models/dataPackValue.model';
import { DataPackCalendar } from 'app/models/dataPackCalendar.model';
import { DataPackService } from 'app/models/DataPackService.model';
import { Package } from 'app/models/package.model';
import { DataPackGroup } from 'app/models/dataPackGroup.model';

/**
 * @author Wesley Mascarenhas
 * @version $Id$
 */
export class DataPackLine {

  public id: string;
  public account: string;
  public userName: string;
  public lineNumber: string;
  public quota: DataPackValue;
  public futureQuota: DataPackValue;
  public quotaConsumption: DataPackValue;
  public percentageConsumedQuota: string;
  public additionalDataPack: DataPackValue;
  public notifyManagerGroup: boolean;
  public blocked: boolean;
  public blockConsumptionStatus: string;
  public calendar: DataPackCalendar;
  public email: string;
  public planDesc: string;
  public additionalPackages: string;
  public grupo: string;
  public statusDescription: string;
  public packageList: Array<Package>;
  public state:string;
  public dataPackGroup:DataPackGroup = new DataPackGroup();
  public groupId:string;
  public groupName:string;
  public hasCallCtrl:boolean;
  public hasSrvGesData:boolean;
  public filtered:boolean;
  public isSharedBalance:boolean;
  public is5GPortifolio:String;

  /* Atributos bloqueio de voz  */
  public blockedLDI: boolean ;
  public blockedOther:boolean;
  public blockedSMS: boolean;
  public blockedManager:boolean;
  public blockedHari: boolean;
  public facilityDataPackServices: Array<DataPackService> = new Array<DataPackService>();
  public lineControlDataPackServices: Array<DataPackService> = new Array<DataPackService>();
  public lineServiceUpdateMultiplo: Array<DataPackService> = new Array<DataPackService>();
  public limit: DataPackValue =  new DataPackValue();
  public consumedLimit: DataPackValue;
  public overBalanceLimit: DataPackValue;
  public consumedOverBalanceLimit: DataPackValue;
  public overBalanceLimitNextCycleControll: DataPackValue;
  public percentageConsumedOverBalanceLimit: String;
  public overBalanceLocalsLimit: DataPackValue;
  public consumedOverBalanceLocalsLimit: DataPackValue;
  public percentageConsumedOverBalanceLocalsLimit: String;
  public overBalanceLocalsLimitNextCycleControll: DataPackValue;
  public overBalanceAllCallsLimit: DataPackValue;
  public consumedOverBalanceAllCallsLimit: DataPackValue;
  public percentageConsumedOverBalanceAllCallsLimit: String;
  public overBalanceAllCallsLimitNextCycleControll: DataPackValue;
  public profile:string;
  public serviceSMSContract:string;

  /* Consumo Individual */
  public quotaConsumptionIndividual: DataPackValue;
  public percentageConsumedQuotaIndividual: string;
  public limitIndividual: DataPackValue =  new DataPackValue();

  /* Vivo Sync */
  public syncAllowed: boolean; // Permissão Vivo Sync
  public syncActivated: boolean; // Vivo Sync Ativado/Desativado (Status do Atlys)

  public constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/app/models/dataPackLine.model.ts